import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CardContent } from '@mui/material';
import FormattedDocumentNode from './FormattedDocumentNode';

function FormattedPage({ namepage, content, components = null }) {
  const { t } = useTranslation([namepage]);
  const contentTranslated = t(content, { returnObjects: true });
  return (
    <CardContent component="main" sx={{ pt: 10 }}>
      <FormattedDocumentNode title={contentTranslated.title} text={contentTranslated.title} children={contentTranslated.children} type={contentTranslated.type} components={components} /* eslint-disable-line react/no-children-prop */ />
    </CardContent>
  );
}

export default FormattedPage;

FormattedPage.propTypes = {
  namepage: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  components: PropTypes.objectOf(PropTypes.element),
};
